<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-form @submit.prevent="addItem">
        <b-row>
          <b-col>
            <b-alert variant="danger" :show="errors">
              Er ging iets mis...
              <ul class="mt-3">
                <li v-for="error in errors">{{error.toString()}}</li>
              </ul>
            </b-alert>
            <b-card>
              <template #header>
                <strong>Nieuwe feestdag</strong>
              </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="10">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="10">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name"/>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row class="mt-4">
                      <b-col cols="12" md="10">
                        <h5>Datum</h5>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Datum">
                          <b-form-input type="date" required v-model="item.date"/>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Vervangende datum">
                          <b-form-input type="date" required v-model="item.replacement_date"/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Bestel deadline (optioneel)">
                          <b-form-input type="date" v-model="item.deadline_date"/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
            </b-card>
          </b-col>
        </b-row>

          </b-row>
          <b-row>
            <b-col cols="12" class="mb-4">
              <b-card>
                <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Opslaan</b-button>
              </b-card>
            </b-col>
          </b-row>
              </b-form>
      </div>
    </div>
  </div>
</template>

<script>
    import {addData} from '../../api';

    export default {
        name: 'holiday-create',
        data() {
            return {
                saveButtonDisabled: false,
                item: {
                    name: null,
                    date: null,
                    replacement_date: null,
                    deadline_date: null,
                },
                errors: null,
            }
        },
        methods: {
            async addItem() {
                this.errors = null;
                this.saveButtonDisabled = true;
                const request = await addData('holidays', this.item);
                if (request.status === 200) {
                    this.$router.push({name: 'holidays.view', params: {id: request.data}});
                } else {
                    this.errors = request.data.errors;
                    this.saveButtonDisabled = false;
                }
            },
        }
    }
</script>
